/*
Possible values include:
"en-US"*
"es-US"*
"en-AU"*
"fr-CA"*
"en-GB"*
"de-DE"*
"pt-BR"*
"fr-FR"*
"it-IT"*
"ko-KR"*
"es-ES"*
"en-IN"*
"hi-IN"*
"ar-SA"*
"ru-RU"*
"zh-CN"*
"nl-NL"*
"id-ID"*
"ta-IN"*
"fa-IR"*
"en-IE"*
"en-AB"*
"en-WL"*
"pt-PT"*
"te-IN"*
"tr-TR"*
"de-CH"*
"he-IL"*
"ms-MY"*
"ja-JP"*
"ar-AE"*
*/
export const supported_languages = [
  {
    type: "en-US",
    language: "English (United States) (en-US)",
    subtitle_title: "English"
  },
  {
    type: "en-AU",
    subtitle_title: "English",
    language: "English (Australia) (en-AU)"
  },
  {
    type: "en-GB",
    subtitle_title: "English",
    language: "English (United Kingdom) (en-GB)"
  },
  {
    type: "en-IN",
    subtitle_title: "English",
    language: "English (India) (en-IN)"
  },
  {
    type: "en-IE",
    subtitle_title: "English",
    language: "English (Ireland) (en-IE)"
  },
  {
    type: "en-AB",
    subtitle_title: "English",
    language: "English (Scotland) (en-AB)"
  },
  {
    type: "en-WL",
    subtitle_title: "English",
    language: "English (Wales) (en-WL)"
  },
  {
    type: "ar-SA",
    subtitle_title: "English",
    language: "Arabic (Saudi Arabia) (ar-SA)"
  },
  {
    type: "ar-AE",
    subtitle_title: "Arabic",
    language: "Arabic (U.A.E.) (ar-AE)"
  },
  {
    type: "zh-CN",
    subtitle_title: "Chinese",
    language: "Chinese (China) (zh-CN)"
  },
  {
    type: "nl-NL",
    subtitle_title: "Dutch",
    language: "Dutch (Netherlands) (nl-NL)"
  },
  {
    type: "fa-IR",
    subtitle_title: "Farsi",
    language: "Farsi (Iran) (fa-IR)"
  },
  {
    type: "fr-FR",
    subtitle_title: "French",
    language: "French (France) (fr-FR)"
  },
  {
    type: "fr-CA",
    subtitle_title: "French",
    language: "French (Canada) (fr-CA)"
  },
  {
    type: "de-DE",
    subtitle_title: "German",
    language: "German (Germany) (de-DE)"
  },
  {
    type: "de-CH",
    subtitle_title: "German",
    language: "German (Switzerland) (de-CH)"
  },
  {
    type: "he-IL",
    subtitle_title: "Hebrew",
    language: "Hebrew (Israel) (he-IL)"
  },
  {
    type: "hi-IN",
    subtitle_title: "Hindi",
    language: "Hindi (India) (hi-IN)"
  },
  {
    type: "id-ID",
    subtitle_title: "Indonesian",
    language: "Indonesian (Indonesia) (id-ID)"
  },
  {
    type: "it-IT",
    subtitle_title: "Italian",
    language: "Italian (Italy) (it-IT)"
  },
  {
    type: "ja-JP",
    subtitle_title: "Japanese",
    language: "Japanese (Japan) (ja-JP)"
  },
  {
    type: "ko-KR",
    subtitle_title: "Korean",
    language: "Korean (Korea) (ko-KR)"
  },
  {
    type: "ms-MY",
    subtitle_title: "Malay",
    language: "Malay (Malaysia) (ms-MY)"
  },
  {
    type: "pt-PT",
    subtitle_title: "Portuguese",
    language: "Portuguese (Portugal) (pt-PT)"
  },
  {
    type: "pt-BR",
    subtitle_title: "Portuguese",
    language: "Portuguese (Brazil) (pt-BR)"
  },
  {
    type: "ru-RU",
    subtitle_title: "Russian",
    language: "Russian (Russia) (ru-RU)"
  },
  {
    type: "es-ES",
    subtitle_title: "Spanish",
    language: "Spanish (Spain) (es-ES)"
  },
  {
    type: "es-US",
    subtitle_title: "Spanish",
    language: "Spanish (Americas) (es-US)"
  },
  {
    type: "ta-IN",
    subtitle_title: "Tamil",
    language: "Tamil (India) (ta-IN)"
  },
  {
    type: "te-IN",
    subtitle_title: "Telugu",
    language: "Telugu (India) (te-IN)"
  },
  {
    type: "tr-TR",
    subtitle_title: "Turkish",
    language: "Turkish (Turkey) (tr-TR)"
  },
  {
    type: "other",
    subtitle_title: "Unknown",
    language: "Other (other)"
  }
];

  
